import * as React from 'react'

import * as utils from '@owl-nest/utils'

export function useRandom(seed = 0): number {
  const id = React.useId()
  const hash = utils.hash.createHash().update('abcdefghijklmnopqrstuvwxuz')
  for (let i = 0; i < seed; i++) {
    hash.update(id)
  }

  const digest = hash.digest('number')

  return (digest % 1000) / 1000
}
